import React, { createContext, useContext } from 'react';

// Swiper's autoHeight is conflicting with changing MUI Collapse element's height
// this context is made to handle this layout issue
export const ContentControlledCarouselContext = createContext({
  handleCollapseChange: () => {},
});

export const useContentControlledCarouselContext = () =>
  useContext(ContentControlledCarouselContext);
